
import React from 'react';
import './home.scss'
import Button from '@material-ui/core/Button';

import { Snackbar } from '@material-ui/core';
import {ReactComponent as ButtonArrow} from '../../assets/icons/nav/buttonarrow.svg';
import CircleLoader from "react-spinners/CircleLoader";
import { css } from "@emotion/react";
import InstallPWA from '../InstallPWA/InstallPWA';
import Help from '../Help/Help';
const loaderStyle = css`
position:relative;
top:40%;
left:35%;
display: block;
border-color: red;

z-index:20;
`;



class Home extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
          openpopover:false,
          anchorEl:null,
          isLoading:true,
             selectedPage: null,
             disabled:true,
             SnackbarEmptyOpen:false,
             SnackbarContentOpen:false,
             currentVh:0,

             contentPages:[12,14,18,19,23,30,56,60,62,74,89,90,98,104,107,108,111,116,118,120,
              122,124,125,129,130,131,133,135,137,142,150,162,167,168,169,170,173,179,180,185,
              198,200,202,209,213,214,219,229,230,232,235,237,242],
              height: window.innerHeight, 
              width: window.innerWidth

             };
        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
      this.handleInfo=this.handleInfo.bind(this);
      this.updateDimensions = this.updateDimensions.bind(this);

      }
      updateDimensions() {
        this.setState({
          height: window.innerHeight, 
          width: window.innerWidth
        });
      }
  
      componentDidMount(){
        window.addEventListener("resize", this.updateDimensions);
        this.setState({selectedPage:null})
        setTimeout(() => { this.setState({ isLoading: false }) }, 1000);

      }
      componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
      }
    
    handleChange(e) {
      var currentPage= parseInt(e.target.value)
     
      switch(currentPage){
        case 18: currentPage=19
        break;
        case 61:currentPage=60
        break;
        case 105: currentPage=104
        break;
        case 124: currentPage=125
        break;
        case 128:currentPage=129
        break;
        case 181: currentPage=180
        break;
        case 182: currentPage=180
        break;
        case 212: currentPage=213
        break;
        default:console.log()

      }
        this.setState({selectedPage:currentPage})
        this.setState({disabled:false})

      }
    
      handleClick(e){
        e.preventDefault();
        
        if(this.state.selectedPage!==null){
          if(this.state.contentPages.indexOf(this.state.selectedPage)>-1){
            if(this.state.selectedPage===242){
              window.location.href="https://www.christineaymon.ch/biographie/"
            }
            else{
              window.location="/choosepage/" + this.state.selectedPage

            }
          }
          else{
            this.setState({SnackbarContentOpen:true})
          }
        }
        else{
          this.setState({SnackbarEmptyOpen:true})
        }
        
        
        
      }
      handleClose(){
        this.setState({SnackbarEmptyOpen:false,SnackbarContentOpen:false})
      }
      handleInfo(event){
    this.setState({anchorEl:event.currentTarget});
this.setState({openpopover:true})      }
   
render(){
    return(
      <>
      {this.state.isLoading &&
        <div className="loaderContainer">
        <CircleLoader color={'red'} loading={this.state.isLoading}size={150} css={loaderStyle}/>

          </div>
      }
     
      
        <div id="homeContainer" style={{"height":this.state.height}}>
     <InstallPWA></InstallPWA>
     <Help></Help>

         
        
            <h1 id="homeSelectText">Inscrire le numéro de page : </h1>
            <input id="numericInput"type="number"placeholder="_ _ _ _ _ _ _" onChange={this.handleChange}/>
            <Button id="homeButton" onClick={this.handleClick} ><ButtonArrow style={{'marginRight':'20px'}}/> Découvrir</Button>
            <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={this.state.SnackbarEmptyOpen} 
                autoHideDuration={3000}
                onClose={this.handleClose}
        message="Veuillez inscrire le numéro de la page."
      
      />
         <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={this.state.SnackbarContentOpen} 
                autoHideDuration={3000}
                onClose={this.handleClose}
        message="Il n'y a pas de contenu à cette page..."
      
      />
        </div>
       

        </>
    )
}

}
export default Home;